import { createSlice } from '@reduxjs/toolkit';

import { initialStore } from '../initial-store';

const cryptoWalletsSlice = createSlice({
  initialState: initialStore.cryptoWalletsPage,
  name: 'cryptoWalletsPage',
  reducers: {
    getCryptoWallets: (state) => {
      state.isLoading = true;
    },
    getCryptoWalletsError: (state) => {
      state.isLoading = false;
    },
    removeCryptoWallet: (state, { payload }) => {
      state.data = state.data.filter((item) => item.id !== payload.id);
    },
    setCryptoWallets: (state, { payload }) => {
      const { count, result } = payload;
      state.data = result;
      state.count = count;
      state.isLoading = false;
    },
    setLoading: (state, { payload }) => {
      state.isLoading = payload;
    },
    updateCryptoWallet: (state, { payload }) => {
      state.data = state.data.map((item) => {
        if (item.id === payload.id) {
          return payload;
        }
        return item;
      });
    }
  }
});

export const {
  getCryptoWallets,
  getCryptoWalletsError,
  removeCryptoWallet,
  setCryptoWallets,
  setLoading,
  updateCryptoWallet
} = cryptoWalletsSlice.actions;

export const { reducer } = cryptoWalletsSlice;
